// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 20px 20px;
  background: white;
  margin: 0;
  position: relative;
}

.close-x {
  position: absolute;
  top: 10px;
  right: 14px;
  background: none;
  border: none;
  font-size: 20px;
  line-height: 1;
  color: #333;
  cursor: pointer;
  padding: 4px 6px;
  z-index: 10;
}

.title {
  font-family: AppFontBold, sans-serif;
  font-size: 28px;
  line-height: 35px;
  text-align: center;
  color: black;
  margin-bottom: 8px;
}

.info {
  font-family: AppFontLight;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: black;
  margin-bottom: 25px;
}

.button {
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}
.button:last-child {
  margin-bottom: 0;
}
.button_main {
  background: var(--ion-color-primary);
  font-family: AppFontBold, sans-serif;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
  color: white;
  border-radius: 16px;
}
.button_close {
  background: transparent;
  font-family: AppFontBold, sans-serif;
  border-radius: 16px;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
  border: 1px solid #ED6958;
  border-radius: 16px;
  color: #ED6958;
}

img {
  margin: 10px;
  min-height: 200px;
  max-height: 62vh;
}`, "",{"version":3,"sources":["webpack://./src/app/components/info-modal/info-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AACF;AAAE;EACE,gBAAA;AAEJ;AACE;EACE,oCAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AACJ;AAEE;EACE,uBAAA;EAEA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AADJ;;AAIA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;AADF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 30px 20px 20px;\n  background: white;\n  margin: 0;\n  position: relative;\n}\n\n.close-x {\n  position: absolute;\n  top: 10px;\n  right: 14px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  line-height: 1;\n  color: #333;\n  cursor: pointer;\n  padding: 4px 6px;\n  z-index: 10;\n}\n\n.title {\n  font-family: AppFontBold, sans-serif;\n  font-size: 28px;\n  line-height: 35px;\n  text-align: center;\n  color: black;\n  margin-bottom: 8px;\n}\n\n.info {\n  font-family: AppFontLight;\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  color:black;\n  margin-bottom: 25px;\n}\n\n.button {\n  height: 60px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n  cursor: pointer;\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &_main {\n    background: var(--ion-color-primary);\n    font-family: AppFontBold, sans-serif;\n    font-size: 20px;\n    line-height: 25px;\n    text-align: center;\n    color: white;\n    border-radius: 16px;\n  }\n\n  &_close {\n    background: transparent;\n\n    font-family: AppFontBold, sans-serif;\n    border-radius: 16px;\n    font-size: 20px;\n    line-height: 25px;\n    text-align: center;\n    border: 1px solid #ED6958;\n    border-radius: 16px;\n    color: #ED6958;\n  }\n}\nimg {\n  margin: 10px;\n  min-height: 200px;\n  max-height: 62vh;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
